<ng-container *ngIf="cart$ | async as cart">
  <div class="row">
    <div class="col-md-6 mt-7 d-flex justify-content-md-start align-headline">
      <h4>{{ 'cartItems.cartTotalSingle' | cxTranslate }}</h4>
      <p class="pl-2 fs-14 cart-total-articles">
        ({{ cart?.deliveryItemsQuantity }} {{ 'cartItems.header.article' | cxTranslate }})
      </p>
      <div>
        <a
          [attr.data-qa]="cartButton?.getButtonId()"
          class="ml-3"
          [routerLink]="{ cxRoute: 'cart' } | cxUrl"
        >
          <app-svg [iconName]="'Edit'" dimension="1.25em"></app-svg>
        </a>
      </div>
    </div>
    <div class="col-12 mb-md-11" *ngIf="entries$ | async as entries">
      <app-cart-item-list
        [items]="entries"
        [activeControls]="false"
        [activateProductLinks]="false"
      ></app-cart-item-list>
    </div>
  </div>
</ng-container>
